import { TILES_GROUP } from '@/modules/tiles/store/schema';
import { setNormalizeEntities } from '@/modules/_global/vuex/mutations';

export default {
  setEntities: setNormalizeEntities(),

  setTilesGroups: (state, tilesGroupsIds) => {
    state.tilesGroupsIds = tilesGroupsIds;
  },

  addTileGroup: (state, tilesGroupId) => {
    if (state.tilesGroupsIds.includes(tilesGroupId)) {
      return;
    }

    state.tilesGroupsIds.push(tilesGroupId);
  },

  setDefaultTilesGroup: (state, tilesGroupId) => {
    if (!tilesGroupId || state.defaultTilesGroupId === tilesGroupId) {
      return;
    }

    if (state.entities[TILES_GROUP][state.defaultTilesGroupId]) {
      state.entities[TILES_GROUP][state.defaultTilesGroupId] = {
        ...state.entities[TILES_GROUP][state.defaultTilesGroupId],
        default: false
      };
    }

    state.defaultTilesGroupId = tilesGroupId;
  },

  setTiles: (state, tilesIds) => {
    state.tilesIds = tilesIds;
  },

  addTile: (state, tileId) => {
    if (state.tilesIds.includes(tileId)) {
      return;
    }

    state.tilesIds.push(tileId);
  },

  removeTile: (state, tileId) => {
    state.tilesIds = state.tilesIds.filter(i => i.id !== tileId);
  },

  setTilesTypes: (state, tilesTypesIds) => {
    state.tilesTypesIds = tilesTypesIds;
  },

  addTilesTypes: (state, tileTypeId) => {
    if (state.tilesTypesIds.includes(tileTypeId)) {
      return;
    }

    state.tilesTypesIds.push(tileTypeId);
  }
};
